export function SwirlLogoAiIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_24_204)">
        <path
          d="M12 0.900391C15.1128 0.900391 17.6163 3.05448 18.0479 5.95117C20.9451 6.38228 23.0996 8.88682 23.0996 12C23.0996 13.7875 22.4871 15.353 21.3604 16.4395L21.1289 16.6504C20.7525 16.9722 20.1963 16.9524 19.8438 16.6162L19.7764 16.5439C19.432 16.1412 19.4791 15.5357 19.8818 15.1914L20.0723 15.0156C20.9797 14.1132 21.1816 12.8983 21.1816 12C21.1816 9.64187 19.4103 7.80273 17.1562 7.80273C15.1396 7.80273 13.4515 9.23342 13.0508 11.1328C15.9239 11.6326 18.1152 14.1422 18.1152 17.1562C18.1152 20.4911 15.4257 23.0996 12 23.0996C8.88682 23.0996 6.38228 20.9451 5.95117 18.0479C3.05448 17.6163 0.900391 15.1128 0.900391 12C0.900391 8.88711 3.05432 6.38257 5.95117 5.95117C6.38257 3.05432 8.88711 0.900391 12 0.900391ZM12.8672 13.0498C12.4273 15.581 10.4282 17.5821 7.89746 18.0234C8.29954 19.8474 9.95382 21.1816 12 21.1816C14.3581 21.1816 16.1973 19.4103 16.1973 17.1562C16.1973 15.1395 14.7667 13.4504 12.8672 13.0498ZM5.97656 7.89746C4.15268 8.29957 2.81836 9.95386 2.81836 12C2.81836 14.3581 4.58969 16.1973 6.84375 16.1973C8.86029 16.1973 10.5475 14.7665 10.9482 12.8672C8.418 12.4266 6.41788 10.4275 5.97656 7.89746ZM12 2.81836C9.64187 2.81836 7.80273 4.58969 7.80273 6.84375C7.80273 8.86011 9.23287 10.5482 11.1318 10.9492C11.572 8.41869 13.5715 6.41718 16.1016 5.97559C15.6991 4.15225 14.0458 2.81836 12 2.81836Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          d="M12 4.16602C12.5299 4.16602 12.959 4.59514 12.959 5.125C12.959 5.65486 12.5299 6.08398 12 6.08398C11.5814 6.08398 11.2402 6.42512 11.2402 6.84375C11.2402 7.37361 10.8111 7.80273 10.2812 7.80273C9.75139 7.80273 9.32227 7.37361 9.32227 6.84375C9.32227 5.36694 10.5232 4.16602 12 4.16602Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          d="M13.7188 16.1973C14.2486 16.1973 14.6777 16.6264 14.6777 17.1562C14.6777 18.6331 13.4768 19.834 12 19.834C11.4701 19.834 11.041 19.4049 11.041 18.875C11.041 18.3451 11.4701 17.916 12 17.916C12.4186 17.916 12.7598 17.5749 12.7598 17.1562C12.7598 16.6264 13.1889 16.1973 13.7188 16.1973Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          d="M5.125 11.041C5.65486 11.041 6.08398 11.4701 6.08398 12C6.08398 12.4186 6.42512 12.7598 6.84375 12.7598C7.37361 12.7598 7.80273 13.1889 7.80273 13.7188C7.80273 14.2486 7.37361 14.6777 6.84375 14.6777C5.36694 14.6777 4.16602 13.4768 4.16602 12C4.16602 11.4701 4.59514 11.041 5.125 11.041Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          d="M17.1562 9.32227C18.6331 9.32227 19.834 10.5232 19.834 12C19.834 12.5299 19.4049 12.959 18.875 12.959C18.3451 12.959 17.916 12.5299 17.916 12C17.916 11.5814 17.5749 11.2402 17.1562 11.2402C16.6264 11.2402 16.1973 10.8111 16.1973 10.2812C16.1973 9.75139 16.6264 9.32227 17.1562 9.32227Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_24_204">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
